import { SvgIcon, SxProps } from "@mui/material";
import SvgCommentIcon from "jsx:../../../Images/Icons/FontAwesome/light/comment-plus.svg";

export function CommentPlusIcon(props: SxProps) {
    return <SvgIcon component={SvgCommentIcon} inheritViewBox sx={props} />;
}
